import React, { useState } from "react";
import { downloadPdf } from "../utils/downloadPdf";

function StatementDownloadForm({ baseUrl, id, filenamePrefix, label }) {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    const params = new URLSearchParams();
    if (from) params.append("from", from);
    if (to) params.append("to", to);
    await downloadPdf(`${baseUrl}/${id}?${params.toString()}`, `${filenamePrefix}-${id}.pdf`);
    setDownloading(false);
  };

  return (
    <div style={styles.wrap}>
      {label && <span style={styles.label}>{label}</span>}
      <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} style={styles.dateInput} />
      <span style={styles.toText}>to</span>
      <input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={styles.dateInput} />
      <button onClick={handleDownload} disabled={downloading} style={styles.downloadBtn}>
        {downloading ? "Downloading..." : "Download Statement"}
      </button>
    </div>
  );
}

const styles = {
  wrap: { display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" },
  label: { fontSize: "13px", fontWeight: "700", color: "#475569", marginRight: "4px" },
  dateInput: { padding: "8px 10px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" },
  toText: { fontSize: "12px", color: "#94a3b8" },
  downloadBtn: {
    padding: "8px 16px", borderRadius: "8px", border: "none",
    background: "#6366f1", color: "#fff", fontWeight: "700", fontSize: "13px", cursor: "pointer",
  },
};

export default StatementDownloadForm;